import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { TranslationPipe } from '@shared/pipes/translation/translation.pipe';

import { BannerService } from '@core/components/layout/banner/services/banner.service';
import { BreadcrumbComponent, ButtonComponent } from '@ctti-dev/ng-gencat';

import { BreadcrumbItem } from './models/breadcrumb.model';
import { BannerButton } from '@shared/models/button.model';

import { ButtonDisableDirective } from '@shared/directives/button-disable.directive';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [
    TranslatePipe,
    RouterModule,
    CommonModule,
    TranslationPipe,
    BreadcrumbComponent,
    ButtonComponent,
    ButtonDisableDirective,
  ],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent implements OnInit, OnDestroy {
  isBannerButtonDisable: WritableSignal<boolean> = signal(false);

  private readonly _bannerService = inject(BannerService);
  private readonly _subscription$ = new Subject<void>();

  breadcrumbs: Signal<BreadcrumbItem[]> = computed(() =>
    this._bannerService.breadcrumbState(),
  );

  title: Signal<string> = computed(
    () => this._bannerService.titleObjSignal().bannerTitle,
  );

  titleBannerId: Signal<string> = computed(() =>
    this._bannerService.bannerId(),
  );

  isBreadcrumbVisible: Signal<boolean> = computed(() =>
    this._bannerService.isBreadcrumbVisible(),
  );

  subtitle: Signal<string> = computed(
    () => this._bannerService.titleObjSignal().bannerSubtitle ?? '',
  );

  ctaButtons: Signal<BannerButton[] | undefined> = computed(() =>
    this._bannerService.ctaBannerButtonsSignal(),
  );

  applyHomeStyle: Signal<boolean> = computed(() =>
    this._bannerService.isHome(),
  );

  ngOnInit(): void {
    this.setBannerButtonDisable();
  }

  ngOnDestroy(): void {
    this._subscription$.complete();
    this._subscription$.unsubscribe();
  }

  private setBannerButtonDisable(): void {
    this._bannerService.isBannerButtonDisable$
      .pipe(takeUntil(this._subscription$))
      .subscribe((isValid) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.isBannerButtonDisable.update((value) => (value = isValid));
      });
  }
}
